if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
    super();

    this.form = this.querySelector("form");
    if (!this.form) return;

    const variantInput = this.form.querySelector("[name=id]");
    if (variantInput) variantInput.disabled = false;

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector("cart-notification");
}

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;
      ddddPostsCount += 1
      ddddDisableCheckoutButton()
      
      if(this.hasAttribute('makeItSpecialAddForm')) {
            var badge = this.parentNode.querySelector('[showAfterAdding]')
            badge.classList.remove('ddddBadgeAnimation')
            badge.classList.remove('ddddBadgeSecondAnimation')
          }
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
.then((response) => {

  if (response.status) {
    this.handleErrorMessage(response.description);
    return;
  }

// ✅ Go to cart after successful add (safe for /ar and /en)
const cartUrl =
  (window.routes && routes.cart_url)
    ? routes.cart_url
    : (location.pathname.startsWith('/ar') ? '/ar/cart' : '/cart');

window.location.href = cartUrl;
return;

ddddPopulateAddons();
        
          if (false && this.hasAttribute('ddddScroll')) {
                             
          var ddddCurrentY = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0)
          var ddddTargetY = document.getElementById('dddd-add-section').offsetTop
          var ddddCurrentTime = 0
          var duration = 1000
          var ddddInterval = setInterval(function() {

            var scroll = -ddddTargetY / 2 * (Math.cos(Math.PI * ddddCurrentTime / duration) - 1) + ddddCurrentY

            window.scrollTo(0, scroll);
            if (scroll >= ddddTargetY) {
              window.scrollTo(0, ddddTargetY);
              clearInterval(ddddInterval)
              ddddShowCheckoutButton();
              addAutoloadScrollEventListener()
            }
            ddddCurrentTime += 20;
          }, 20);
      	}

      addAutoloadScrollEventListener();

       
        var price = null
        var parent = this.parentNode
        var n = 0

        while(n<3 && !price) {
          n++
          price = parent.querySelector('[ddddPrice]')
          parent = parent.parentNode
        }

        // We calculate subtotal here in order to update 
        var subTotal = ddddGetSubTotal(price.innerHTML, ddddSubTotal)

        if(this.hasAttribute('makeItSpecialAddForm')) {
          var badge = this.parentNode.querySelector('[showAfterAdding]')
          if(badge.style.display == 'none') {
            badge.style.display = 'flex'
            badge.classList.add('ddddBadgeAnimation')
          } else {
            badge.classList.add('ddddBadgeSecondAnimation')
          }
          document.getElementById('ddddSubTotal').innerHTML = subTotal
        }
        
        var openCartNotification = this.hasAttribute('makeItSpecialAddForm') ? true : false
if (this.cartNotification && this.cartNotification.ddddRenderContents) {
  this.cartNotification.ddddRenderContents(response, openCartNotification);
}
        //  this.cartNotification.renderContents(response);
        
      })
      .catch((e) => {
          console.error(e);
      })
      .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
          ddddPostsCount -= 1
          if(ddddPostsCount == 0) ddddEnableCheckoutButton()
            }
      );
     }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
